import { render, staticRenderFns } from "./ViewProcess.vue?vue&type=template&id=1501bc4c&"
import script from "./ViewProcess.vue?vue&type=script&lang=js&"
export * from "./ViewProcess.vue?vue&type=script&lang=js&"
import style0 from "./ViewProcess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports